import { useTranslation } from "react-i18next"

import { useHeaderControlsContext } from "~/components/contexts/useHeaderControlsContext"

export const useBuildBusinessPartnerSorts = () => {
  const { t } = useTranslation(["traceability", "suppliers"])
  const { sorts, setSorts } = useHeaderControlsContext()
  return {
    sorts,
    setSorts,
    sortOptions: [
      {
        label: t("contactTable.columns.status.name"),
        value: "active",
      },
      {
        label: t("contactTable.columns.type.name"),
        value: "type",
      },
      {
        label: t("contactTable.columns.company.name"),
        value: "company",
      },
      {
        label: t("contactTable.columns.code.name"),
        value: "supplierCode",
      },
      {
        label: t("contactTable.columns.tags.name"),
        value: "tags",
      },
      {
        label: t("contactTable.columns.location.name"),
        value: "city",
      },
      {
        label: t("contactTable.columns.productionSites.name"),
        value: "productionSites",
      },
      {
        label: t("contactTable.columns.contactName.name"),
        value: "name",
      },
      {
        label: t("contactTable.columns.contactEmail.name"),
        value: "email",
      },
    ],
  }
}
